<template>

  <footer class="ns-footer-area bg-default ns-footer-area-6">
    <img src="/assets/img/footer/footer-shape-1.png" alt="Not Found" class="ns-footer-shape-1 ns-footer-shape">
    <img src="/assets/img/footer/footer-map.png" alt="Not Found" class="ns-footer-shape-2 ns-footer-shape">
    <img src="/assets/img/footer/footer-map-6.png" alt="Not Found" class="ns-footer-6-shape-3 ns-footer-shape">
    <div class="ns-footer-top pt-95 pb-55">
        <div class="container">
            <div class="row justify-content-between mobile_3">
                <div class="col-xl-3 col-lg-5 col-md-6">
                    <div class="ns-footer-widget mb-40">
                        <div class="ns-footer-logo">
                            <a href="index.html"><img src="/asetet/logo_w.png" width="80%"></a>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-5 col-md-5">
                    <div class="ns-footer-widget mb-40">
                        <p class="ns-footer-widget-title">info@gpro-ks.com</p>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-5 col-md-6">
                    <div class="ns-footer-widget mb-40">
                        <p class="ns-footer-widget-title">+383 49 200 203</p>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-5 col-md-5">
                    <div class="ns-footer-widget mb-40">
                        <p class="ns-footer-widget-title">+383 45 694 444</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="ns-footer-copyright">
            <div class="row">
                <div class="col-xl-6 col-md-6 col-sm-7">
                    <div class="ns-footer-copyright-text">
                        <p>Copyright &copy;<span> Gpro</span> all rights reserved.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </footer>

</template>



<script>

    export default {

        data () {
            return {
               
            }
        },


        mounted:function(){

           

        },


        components: {

        }


    }

</script>

